export enum MenuItemAction {
  ISSUE_WITH_VIDEO_OR_SOUND = "ISSUE_WITH_VIDEO_OR_SOUND",
  SELECT_DEVICES = "SELECT_DEVICES",
  CHAT = "CHAT",
  EDIT_NAME = "EDIT_NAME"
}

export interface MenuItem {
  text: string;
  icon: string;
  value?: MenuItemAction;
  tooltipText?: string;
}
